export default __webpack_public_path__ + "static/media/avatar1.9a91440c.png";